import { createIcon } from './createIcon';

/** Lightbulb outline — the catalog of example prompts. */
export const ExamplesIcon = createIcon({
  name: 'ExamplesIcon',
  viewBox: '0 0 20 20',
  size: 16,
  color: 'var(--text-secondary)',
  children: (
    <>
      <path
        d="M10 2.5C7.24 2.5 5 4.74 5 7.5C5 9.16 5.81 10.63 7.06 11.55C7.42 11.82 7.5 12.15 7.5 12.5V13.5H12.5V12.5C12.5 12.15 12.58 11.82 12.94 11.55C14.19 10.63 15 9.16 15 7.5C15 4.74 12.76 2.5 10 2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M8 15.5H12M8.75 17H11.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
});

export default ExamplesIcon;
